import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar } from '@fortawesome/free-solid-svg-icons';

const Confetti = ({number = 18, loopAnimation = true, playAnimation = false, toggleAnimation, extraStyles = {} }) => {
  let confetti = []
  let confettiClass = '';

  if( loopAnimation === false ) {
    if( playAnimation === true ) {
      confettiClass = "confetti--animate"
    }
  } else {
    confettiClass = "confetti--animate"
  }
  for( let i = 0; i < number; i++ ) {
    confetti.push(<div key={i} onAnimationEnd={toggleAnimation} className={`confetti ${confettiClass}`} >
      <FontAwesomeIcon icon={faStar} size="1x" />
    </div>)
  }

  return (
    <div id="confettis" className={`${loopAnimation ? 'looped' : ''}`} style={extraStyles}>
     {confetti}
    </div>
  );
};

export default Confetti;
